import React from 'react';
import { cx } from './cx';

export interface AdminPillTabItem<K extends string | number = string> {
  key: K;
  label: React.ReactNode;
  /** số đếm/nhãn nhỏ trong viên trắng sau nhãn */
  count?: React.ReactNode;
  disabled?: boolean;
}

export interface AdminPillTabsProps<K extends string | number = string> {
  items: AdminPillTabItem<K>[];
  value: K;
  onChange: (key: K) => void;
  ariaLabel?: string;
  className?: string;
}

// Bộ lọc trạng thái dạng tab viên thuốc 36px, thay cho các ô đếm màu đặc cũ.
export function AdminPillTabs<K extends string | number = string>({
  items,
  value,
  onChange,
  ariaLabel,
  className,
}: AdminPillTabsProps<K>) {
  return (
    <div role="tablist" aria-label={ariaLabel} className={cx('adm-tabs', className)}>
      {items.map((it) => {
        const active = it.key === value;
        return (
          <button
            key={String(it.key)}
            type="button"
            role="tab"
            aria-selected={active}
            disabled={it.disabled}
            className={cx('adm-tab', active && 'adm-tab--active')}
            onClick={() => !active && onChange(it.key)}
          >
            {it.label}
            {it.count !== undefined && it.count !== null && <span className="adm-tab__count">{it.count}</span>}
          </button>
        );
      })}
    </div>
  );
}

export default AdminPillTabs;
